import React, { useCallback, useEffect, useRef, useState } from "react"
import { Button, Modal, ProgressBar } from '@themesberg/react-bootstrap'
import { calculateReward, getCalculateRewardProgress } from '../../../../../controller/api/__loto__/result'
import { useCookies } from 'react-cookie'

export default (props) => {
  const [done, setDone] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [progress, setProgress] = useState({ totalRewardTicket: 0, totalUnrewardTicket: 0, totalPendingTicket: 0, totalRewardAmount: '0' })
  const [progressComplete, setProgressComplete] = useState(false)
  const prevShow = useRef(props.show)
  const progressRef = useRef(progress)
  useEffect(() => {
    progressRef.current = progress
  }, [progress])

  const [cookies] = useCookies(['lottmekong'])

  const _onCalculating = useCallback(async () => {
    setIsLoading(true)
    setError('')
    try {
      const response = await calculateReward(cookies.lottmekong, props.resultId)
      if (response) {
        setDone(true)
      } else {
        setError('Không thể gửi yêu cầu tính thưởng')
      }
    } catch (e) {
      setError('Không thể gửi yêu cầu tính thưởng')
    } finally {
      setIsLoading(false)
    }
  }, [cookies.lottmekong, props.resultId])

  const _fetchProgress = useCallback(async () => {
    if (!props.resultId) {
      return
    }
    const applyResponse = (r) => {
      const tr = Number(r.totalRewardTicket || 0)
      const tu = Number(r.totalUnrewardTicket || 0)
      const tp = Number(r.totalPendingTicket || 0)
      setProgress({
        totalRewardTicket: tr,
        totalUnrewardTicket: tu,
        totalPendingTicket: tp,
        totalRewardAmount: r.totalRewardAmount || '0'
      })
      return r.isDone === true
    }

    const response = await getCalculateRewardProgress(cookies.lottmekong, props.resultId)
    if (!response) {
      return
    }
    const done = applyResponse(response)
    if (done) {
      const finalResponse = await getCalculateRewardProgress(cookies.lottmekong, props.resultId)
      if (finalResponse) {
        applyResponse(finalResponse)
      }
      setProgressComplete(true)
    }
  }, [cookies.lottmekong, props.resultId])

  useEffect(() => {
    if (!prevShow.current && props.show) {
      prevShow.current = true
      setDone(false)
      setProgressComplete(false)
      setProgress({ totalRewardTicket: 0, totalUnrewardTicket: 0, totalPendingTicket: 0, totalRewardAmount: '0' })
      _onCalculating()
      return
    }

    if (prevShow.current && !props.show) {
      prevShow.current = false
      setDone(false)
      setProgressComplete(false)
      setError('')
    }
  }, [props.show, _onCalculating])

  useEffect(() => {
    if (!props.show || !done || progressComplete) {
      return
    }
    _fetchProgress()
    const timer = setInterval(() => {
      _fetchProgress()
    }, 2000)
    return () => clearInterval(timer)
  }, [props.show, done, progressComplete, _fetchProgress])

  const _onHide = () => {
    if (isLoading) {
      alert('Đang gửi yêu cầu tính thưởng')
      return
    }
    const p = progressRef.current
    props.onHide(p.totalRewardTicket, p.totalUnrewardTicket, async () => {
      setDone(false)
      setProgressComplete(false)
      setError('')
    })
  }

  const totalProcessed = Number(progress.totalRewardTicket || 0) + Number(progress.totalUnrewardTicket || 0)
  const totalTicket = totalProcessed + Number(progress.totalPendingTicket || 0)
  const progressPercent = totalTicket > 0 ? Math.round((totalProcessed * 100) / totalTicket) : 0

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Tính thưởng kỳ #{props.period && props.period.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading && 'Đang gửi yêu cầu tính thưởng...'}
        {!isLoading && done && !progressComplete && 'Đã gửi yêu cầu tính thưởng thành công'}
        {!isLoading && !done && error}
        {!isLoading && done && progressComplete && (
          <>
            <div className="text-success"><b>Hoàn tất tính thưởng</b></div>
            <br />Tổng vé: <b>{totalTicket}</b>
            <br />Vé trúng: <b>{progress.totalRewardTicket}</b>
            <br />Vé không trúng: <b>{progress.totalUnrewardTicket}</b>
            <br />Tổng tiền thưởng: <b>{new Intl.NumberFormat('vn-VI').format(Number(progress.totalRewardAmount || 0))}</b>
          </>
        )}
        {!isLoading && done && !progressComplete && (
          <>
            <br />Tiến độ: <b>{progressPercent}%</b>
            <ProgressBar className={`progress-md`} variant={'success'} now={progressPercent} min={0} max={100} />
            <br />Vé trúng: <b>{progress.totalRewardTicket}</b>
            <br />Vé không trúng: <b>{progress.totalUnrewardTicket}</b>
            <br />Vé chờ xử lý: <b>{progress.totalPendingTicket}</b>
            <br />Tổng tiền thưởng: <b>{new Intl.NumberFormat('vn-VI').format(Number(progress.totalRewardAmount || 0))}</b>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={_onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
